module.exports = __webpack_public_path__ + "img/beta-logo.4373b705.png";